import styled from "styled-components";
import FlexBox from "../FlexBox/FlexBox";
import { TypographyScale } from "../../Foundation/Typography/Typography.styles";
import { useTheme } from "../../Themes/defaultTheme";
import { responsiveMap } from "../Grid/_utils/responsiveObserve";

export const DELIVERY_OPTIONS_TRANSITION_DURATION = "0.25s";

export const _DeliveryOptionsStatusRoot = styled(FlexBox<"span">)<{
  visible: boolean;
  $action?: boolean;
}>(({ visible = true }) => {
  return {
    display: "flex",
    transition: `transform ${DELIVERY_OPTIONS_TRANSITION_DURATION} ease, opacity ${DELIVERY_OPTIONS_TRANSITION_DURATION} ease`,
    maxWidth: "100%",
    boxShadow: "0px 3px 0px 0px #000",
    ...(!visible && {
      opacity: 0,
      transform: "translateY(-88px)",
    }),
    [".delivery-options-status-badge"]: {
      display: "none",
    },
    [`@media ${responsiveMap.mobile}`]: {
      //background: "#141414",
      width: "100%",
      height: 64,
      padding: "0 16px",
      ...(!visible && {
        opacity: 1,
        transform: "translateY(0)",
      }),
      [".delivery-options-status-badge"]: {
        display: "flex",
      },
    },
  };
});
export const _DeliveryOptionsStatusButtonWrapper = styled("button")<{
  search?: boolean;
  select?: boolean;
}>(({ search = true, select = false }) => {
  const {
    color: { white, champagne2, champagne4, champagne7, inputBorder },
  } = useTheme();
  return {
    display: "inline-flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "44px",
    padding: "13px 10px",
    lineHeight: "18px",
    border: "none",
    borderRadius: "44px",
    color: champagne7,
    textDecoration: "none",
    background: white,
    userSelect: "none",
    cursor: "pointer",
    overflow: "hidden",
    whiteSpace: "nowrap",
    ...TypographyScale["button2"],
    ...(select && {
      marginRight: "8px",
    }),
    [`@media ${responsiveMap.mobile}`]: {
      width: "100%",
      margin: "10px 0",
      ["&:first-child"]: {
        display: "none",
      },
      ...(!search && {
        display: "none",
      }),
      [".primary-label"]: {
        flex: 1,
        ["span"]: {
          textAlign: "left",
        },
      },
    },
    [">span"]: {
      display: "flex",
      gap: 8,
      padding: "0 8px",
      whiteSpace: "nowrap",
      minWidth: select ? "100%" : "1px",
      ["&:first-child"]: {
        flex: 1,
      },
      // flex: 1,
      [">span"]: {
        margin: "-2px 0 0 0",
        whiteSpace: "nowrap",
        overflow: "hidden",
        maxHeight: "18px",
        textOverflow: "ellipsis",
      },
      [":nth-child(2)"]: search
        ? {
            background: champagne2,
            color: white,
            width: 37,
            maxWidth: 37,
            height: 37,
            minWidth: 37,
            borderRadius: 37,
            fontSize: 16,
            margin: "0 -6px 0 6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: `background ${DELIVERY_OPTIONS_TRANSITION_DURATION} ease`,
          }
        : {
            borderLeft: `solid 1px ${inputBorder}`,
          },
    },
    [":hover"]: {
      [">span"]: {
        [":nth-child(2)"]: {
          background: search ? champagne4 : undefined,
        },
      },
    },
  };
});

export const _DeliveryOptionsStatusBadgeRoot = styled("button")<{
  wrapper: "Navigation" | "Cart";
}>(({ wrapper = "Navigation" }) => {
  const isCart = wrapper === "Cart";
  const { color } = useTheme();
  return {
    display: "flex",
    flexDirection: "row",
    padding: isCart ? "12px 16px 16px" : "10px 0",
    flexWrap: "wrap",
    border: 0,
    cursor: "pointer",
    background: isCart ? color.beigeBg : "transparent",
    width: "100%",
    ["span"]: {
      display: "flex",
      lineHeight: "20px",
      ["i"]: {
        margin: "auto 4px 0 0",
      },
    },
    ["span:nth-child(1)"]: {
      margin: "0 auto 0 0",
    },
    ["span:nth-child(2)"]: {
      margin: "0 0 0 0",
    },
    ["span:nth-child(3)"]: {
      width: "100%",
      flexGrow: 1,
    },
    ...(isCart && {
      borderRadius: 4,
      gap: 4,
      margin: "0 0 12px",
      [".ro-typography"]: {
        color: color.champagne7,
      },
    }),
  };
});
